import { AxiosInstance, AxiosPromise } from 'axios';
import {
  AccountServicesEndpoint,
  GetAccountRequest,
  GetAccountResponse,
  SearchAccountsRequest,
} from './AccountServices.types';

export class AccountServices implements AccountServicesEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  getById(request: GetAccountRequest): AxiosPromise<GetAccountResponse> {
    return this.instance.get(`/account/${request.routeParams.type}/${request.routeParams.guid}`);
  }

  search(request: SearchAccountsRequest): AxiosPromise<GetAccountResponse[]> {
    return this.instance.get(`/account/${request.routeParams.type}`, {
      params: request.queryParams,
      paramsSerializer: (params) =>
        Object.entries(params)
          .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
          .join('&'),
    });
  }
}
